import { createContext, useContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import { fireEvent, parsePassengerObject } from 'common/js/salesforce/helpers';

const BookingStateDispatchContext = createContext(null);

export const useBookingStateDispatch = () =>
  useContext(BookingStateDispatchContext);

export const bookingStateReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_DATE_AND_VEHICLE': {
      const { dates, vehicles } = action.payload;
      const formatDates = dates.map((item) => item.split('T')[0]);
      const [firstTravelDate, lastTravelDate] = formatDates;
      return {
        ...state,
        vehicles,
        firstTravelDate,
        lastTravelDate,
      };
    }
    case 'UPDATE_PASSENGER': {
      const { passengers, types } = action.payload;
      const newPax = parsePassengerObject({ passengers, types });
      return {
        ...state,
        passengers: newPax,
      };
    }
    default:
      return state;
  }
};

function BookingStateCrmProvider({ children }) {
  const [values, dispatch] = useReducer(bookingStateReducer, {});

  useEffect(() => {
    fireEvent('bookingStateUpdate', values);
  }, [values]);

  return (
    <BookingStateDispatchContext.Provider value={dispatch}>
      {children}
    </BookingStateDispatchContext.Provider>
  );
}

export default BookingStateCrmProvider;

BookingStateCrmProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
